var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from "@angular/core";
import { HoshinBudgetService } from "../hoshin-budget.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { DatePipe } from "@angular/common";
import { SelfService } from "src/app/bpg-self-services/self-services.service.ts";
import { Router } from "@angular/router";
import { BpgCommonService } from "src/app/bpg-common/services/bpg-common.service";
var HoshinComponent = /** @class */ (function () {
    function HoshinComponent(hoshinService, spinner, datepipe, userService, router, bpgCommonService) {
        this.hoshinService = hoshinService;
        this.spinner = spinner;
        this.datepipe = datepipe;
        this.userService = userService;
        this.router = router;
        this.bpgCommonService = bpgCommonService;
        //common
        this.adminId = localStorage.getItem("adminId");
        this.loginData = JSON.parse(localStorage.getItem("loginData"));
        this.userId = this.loginData["userId"];
        this.yearList = [];
        this.removeToolbar = {
            disableNativeSpellChecker: false,
            toolbar: "Basic",
            uiColor: "#FFFFFF",
            basicEntities: false,
            fillEmptyBlocks: false,
            removeButtons: "Source,Save,NewPage,Preview,Print,Templates,Pasteas plain text,PastefromWord,Find,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,SelectionField,Button,ImageButton,HiddenField,Italic,Decrease,Increase,Block,Create Div Container,Text direction from left to right,Text direction from right to left,Set language,Link,Unlink,Image,Flash,Table,Horizontal,Smiley,Insert Special Character,Insert Page Break for Printing,IFrame,Formatting,Paragraph,Font,FontSize,TextColor,Maximize,ShowBlocks,About,forceSpellChecker,Cut,Copy,Paste,Undo,Redo,Anchor,Underline,Strike,Subscript,Superscript,Bold,RemoveFormat",
            height: "130px",
            Backgroundcolor: "black !important",
        };
        //new initiative
        this.affinityGoals = "";
        this.chapterGoals = "";
        this.addToCalendar = true;
        this.frequencyList = [];
        this.initiativeList = [];
        this.printInitiativeHoshinList = [];
        this.printTimestamp = '';
        this.kpiList = [];
        this.selectedKpiList = [];
        this.prevAffinityGoals = "";
        this.prevchapterGoals = "";
        this.prevInitiativeList = [];
        this.addCustomKpi = false;
        this.errorMsg = "";
        this.errorMsgForMissingKpi = "";
        this.selectedChapter = false;
        this.bpgList = [];
        this.siteList = [];
        this.siteId = null;
        this.bpgId = null;
        //review details
        this.highlights = "";
        this.challenges = "";
        this.hoshinList = [];
        this.isKpiReviewSelected = true;
        this.isOverallReviewSelected = false;
        this.isDetailsClicked = true;
        this.isKpiClicked = false;
        this.isGoalsSelected = false;
        this.isInitiativesSelected = true;
        this.isAddNewInitiative = false;
        this.isViewClicked = false;
        this.newkpiCount = 0;
        this.kpiNameEditable = false;
        this.kpiExist = false;
        this.cloneDisable = false;
        //approval
        this.approveOrRejectHoshin = false;
        this.hoshinApproveClicked = false;
        this.approveRejectComment = "";
        this.hoshinApproved = false;
        this.hoshinRejected = false;
        this.hoshinSubmitted = false;
        this.readOnly = false;
        this.isAllHoshinsApproved = false;
        this.resetHoshinEvaluation = [];
        this.totalApprovedBudget = "-";
        this.adminsEdit = false;
        this.pastHoshinList = [];
        this.isNaacAdmin = false;
        this.isNaacViewOnly = false;
        this.errorMsgForMissingMandatoryFields = "";
        this.isAdditionalFundingSelected = false;
        this.isAnyInitiativeRejected = false;
        this.showDeclineAllModal = false;
        this.declineAllComment = '';
        this.overallHoshinApproved = false;
        this.overallHoshinRejected = false;
        this.submitButtonClicked = false;
        this.kpiReviewMissingFields = "";
        this.overallReviewMissingFields = "";
        this.enableSaveInitiativeButton = false;
        this.singleChapterAdmin = false;
        this.printHoshinsList = [];
        this.currentHoshin = [];
        this.dataTargetConstant = "data-target";
        this.dataToggleConstant = "data-toggle";
        //reflection
        this.disabledReflection = true;
        this.refIsActive = true;
        this.maxLength = 2000;
        this.reflectionChangesDisabled = true;
        this.reflectionStatusforPastFY = false;
        this.prevHoshinStatus = "";
        this.showReflectionPopup = false;
        this.additionalAdminComments = "";
        this.autoRedirectTimeout = null;
        this.isCurrentHoshinIncomplete = true;
    }
    HoshinComponent.prototype.kpiDisable = function () {
        if (this.fiscalYear <= 2026) {
            this.why = " ";
            this.plan = " ";
            this.how = " ";
            this.locationWhere = " ";
            this.what = " ";
        }
        if (this.bpgInitiative &&
            this.businessDrivers &&
            this.proposedBudget >= 0 &&
            this.actionPlan &&
            this.why &&
            this.plan &&
            this.how &&
            this.locationWhere &&
            this.what &&
            this.frequency &&
            this.hoshinId !== 0) {
            if (this.frequency.toLowerCase() === "once") {
                if (this.estimatedTiming) {
                    return false;
                }
            }
            else {
                return false;
            }
        }
        return true;
    };
    HoshinComponent.prototype.ngOnInit = function () {
        this.logUserAction();
        this.userAndRoleIdDTO = {
            userId: this.loginData["userId"],
            roleId: localStorage.getItem("adminId"),
        };
        if (localStorage.getItem("loginData") === null ||
            localStorage.getItem("loginData") === undefined) {
            this.router.navigate(["/log-out"]);
        }
        if (localStorage.getItem("logOutFlag") === "true") {
            this.router.navigate(["/log-out"]);
        }
        if (localStorage.getItem("isbpgAdmin") === "true") {
            this.isbpgAdmin = true;
        }
        if (localStorage.getItem("isbpgLeadAdmin") === "true") {
            this.isbpgLeadAdmin = true;
        }
        if (localStorage.getItem("isNaacAdmin") === "true") {
            this.isNaacAdmin = true;
        }
        this.isNaacAdmin = this.isNaacUser();
        if (this.adminId === "1" ||
            this.adminId === "2" ||
            this.adminId === "3" ||
            this.isbpgLeadAdmin ||
            this.isbpgAdmin ||
            (this.isbpgAdmin && this.isbpgLeadAdmin && this.isNaacAdmin) ||
            this.adminId === "4" ||
            this.isNaacAdmin) {
            this.siteId = sessionStorage.getItem("siteIdForHoshin");
            this.bpgId = sessionStorage.getItem("bpgIdForHoshin");
            this.fy = sessionStorage.getItem("fiscalYear");
            this.fetchData();
        }
        this.frequencyList = [
            { type: "Once" },
            { type: "Monthly" },
            { type: "Quarterly" },
        ];
        if (localStorage.getItem("isMultiChapterAdmin") !== "true") {
            this.singleChapterAdmin = true;
        }
    };
    Object.defineProperty(HoshinComponent.prototype, "businessDriversList", {
        get: function () {
            if (this.fiscalYear <= 2026) {
                return [
                    { type: "Team Member Engagement" },
                    { type: "Community Engagement" },
                    { type: "Workforce Readiness" },
                    { type: "Business Support" },
                ];
            }
            return [
                { type: "Team Member Engagement" },
                { type: "Community Engagement" },
                { type: "Career Readiness Support" },
            ];
        },
        enumerable: true,
        configurable: true
    });
    HoshinComponent.prototype.fetchData = function () {
        this.resetAllData();
        this.fetchPrintHoshins();
    };
    HoshinComponent.prototype.fetchPrintHoshins = function () {
        var _this = this;
        this.spinner.show();
        var hoshinData = {
            userId: this.userId,
            adminId: this.adminId,
            bpgId: this.bpgId,
            siteId: this.siteId,
        };
        this.hoshinService.getPastHoshins(hoshinData).subscribe(function (res) {
            if (res != null && res !== undefined) {
                if (res.pastHoshins.length > 0) {
                    _this.pastHoshinList = res.pastHoshins;
                }
                if (res.currentHoshin != null) {
                    _this.currentHoshin.push(res.currentHoshin);
                    _this.printHoshinsList = _this.printHoshinsList.concat(_this.currentHoshin);
                }
                if (_this.pastHoshinList.length > 0) {
                    _this.pastHoshinList[0].show = true;
                    _this.printHoshinsList = _this.printHoshinsList.concat(_this.pastHoshinList);
                }
                if (_this.adminId === "4" || _this.isNaacAdmin) {
                    _this.selectedChapter = true;
                }
            }
            setTimeout(function () {
                _this.spinner.hide();
            }, 2000);
        });
    };
    HoshinComponent.prototype.selectHoshin = function (budgetId) {
        var _this = this;
        this.spinner.show();
        for (var _a = 0, _b = this.printHoshinsList; _a < _b.length; _a++) {
            var printHoshin = _b[_a];
            if (printHoshin.budgetId === budgetId) {
                printHoshin.show = true;
            }
            else {
                printHoshin.show = false;
            }
        }
        setTimeout(function () {
            _this.printHoshin();
        }, 2000);
    };
    HoshinComponent.prototype.resetAllData = function () {
        //new initiative
        this.affinityGoals = "";
        this.chapterGoals = "";
        this.bpgInitiative = null;
        this.businessDrivers = null;
        this.frequency = null;
        this.proposedBudget = null;
        this.approvedBudget = null;
        this.leadId1 = null;
        this.leadId2 = null;
        this.additionalFunding = null;
        this.additionalFundingSource = null;
        this.actionPlan = null;
        this.why = null;
        this.plan = null;
        this.how = null;
        this.locationWhere = null;
        this.what = null;
        this.initiativeList = [];
        this.estimatedTiming = null;
        this.selectedMonthYear = null;
        this.prevFy = null;
        this.prevFyShort = null;
        this.prevAffinityGoals = "";
        this.prevchapterGoals = "";
        this.prevInitiativeList = [];
        this.hoshinId = null;
        this.addCustomKpi = false;
        this.addToCalendar = true;
        this.errorMsg = "";
        this.errorMsgForMissingKpi = "";
        this.isAdditionalFundingSelected = false;
        this.highlights = "";
        this.challenges = "";
        this.hoshinList = [];
        this.hoshinBase = null;
        this.isKpiReviewSelected = true;
        this.isOverallReviewSelected = false;
        this.isDetailsClicked = true;
        this.isKpiClicked = false;
        this.isGoalsSelected = false;
        this.isInitiativesSelected = true;
        this.isAddNewInitiative = false;
        this.kpiName = null;
        this.kpiCount = null;
        this.isViewClicked = false;
        this.newkpiCount = 0;
        this.selectedKpi = "";
        this.isEditKpi = false;
        this.isNextYearPlanCompleted = false;
        this.hoshinSuccess = false;
        this.userList = [];
        this.kpiSuccess = false;
        this.kpiNameEditable = false;
        this.kpiExist = false;
        this.kpi = null;
        this.isCloned = false;
        this.isAddNewInitiativeButtonSelected = false;
        this.cloneDisable = false;
        this.isAddNewInitiativeSelected = false;
        this.initiativeName = null;
        this.approveOrRejectHoshin = false;
        this.approvedAmount = null;
        this.hoshinApproveClicked = false;
        this.approveRejectComment = "";
        this.hoshinApproved = false;
        this.hoshinRejected = false;
        this.hoshinSubmitted = false;
        this.readOnly = false;
        this.isSuperAdminApproved = false;
        this.isAllHoshinsApproved = false;
        this.isAnyInitiativeRejected = false;
        this.resetHoshinEvaluation = [];
        this.totalProposedBudget = null;
        this.totalApprovedBudget = null;
        this.adminsEdit = false;
        this.claimedAmount = null;
        this.pastHoshinList = [];
        this.printHoshinsList = [];
        this.currentHoshin = [];
        this.reflectionStatusforPastFY = false;
        this.getYears();
    };
    HoshinComponent.prototype.changeIsActive = function (data) {
        this.refIsActive = true;
        this.yearList.map(function (res) {
            if (res === data) {
                res.isActive = true;
            }
            else {
                res.isActive = false;
            }
        });
        this.getHoshinDetails(data.year, data.type);
        this.kpiName = null;
        this.selectedKpi = null;
        this.kpi = null;
        this.kpiCount = null;
        this.addCustomKpi = false;
        this.isKpiClicked = false;
        this.isDetailsClicked = true;
        this.cloneDisable = false;
        this.isAddNewInitiativeSelected = false;
    };
    HoshinComponent.prototype.getYears = function (type) {
        var _this = this;
        this.selectedChapter = true;
        var userData = {
            userId: this.userId,
            adminId: this.adminId,
            siteId: this.siteId,
            bpgId: this.bpgId,
            fiscalYear: Number(this.fy),
        };
        this.hoshinService.getHoshinYears(userData).subscribe(function (res) {
            _this.spinner.show();
            if (res != null && res !== undefined) {
                _this.yearList = res;
                if (type === "saveReview") {
                    _this.yearList.map(function (res) {
                        if (res.year === _this.fiscalYear && res.type === "reflection") {
                            res.isActive = true;
                        }
                        else {
                            res.isActive = false;
                        }
                    });
                    _this.getHoshinDetails(_this.fiscalYear, "reflection");
                }
                else {
                    _this.yearList.map(function (res) {
                        res.isActive = false;
                    });
                    //hoshin default screen start view
                    if (_this.yearList.length > 1 &&
                        _this.yearList[1].enabled === true &&
                        _this.reflectionStatusforPastFY) {
                        _this.getHoshinDetails(_this.yearList[1].year, _this.yearList[1].type);
                        _this.yearList[1].isActive = true;
                    }
                    else {
                        _this.getHoshinDetails(_this.yearList[0].year, _this.yearList[0].type); ///entry point : normal case
                        _this.yearList[0].isActive = true;
                    }
                }
            }
        });
    };
    HoshinComponent.prototype.getLeadDetails = function () {
        var _this = this;
        var landingDto = {
            filter: {
                chapterId: this.chapterId,
            },
            moduleId: 0,
            page: 0,
            presentRole: "",
            searchTerm: "",
            size: 0,
            sortDirection: "ASC",
            sortProperty: "",
            uid: "",
        };
        this.userService.getUserDropDown(landingDto).subscribe(function (data) {
            _this.userList = data;
            _this.userList.map(function (i) {
                i.userFirstName = i.userFirstName + " " + i.userLastName;
                return i;
            });
        });
    };
    HoshinComponent.prototype.toggleCheckbox = function (e) {
        if (e.checked) {
            this.hoshinApproveClicked = true;
        }
        else {
            this.hoshinApproveClicked = false;
        }
    };
    HoshinComponent.prototype.getHoshinDetails = function (fiscalYear, type, flag) {
        var _this = this;
        this.spinner.show();
        this.submitButtonClicked = false;
        this.hoshinSuccess = false;
        this.isGoalsSelected = false;
        this.isInitiativesSelected = true;
        this.isEditKpi = false;
        this.displayType = type;
        this.isAddNewInitiative = false;
        this.kpiSuccess = false;
        this.approveOrRejectHoshin = false;
        this.newApprovedAmountGreater = false;
        this.errorMsg = "";
        var hoshinData = {
            userId: this.userId,
            adminId: this.adminId,
            fiscalYear: fiscalYear,
            type: type,
            siteId: this.siteId,
            bpgId: this.bpgId,
        };
        this.fiscalYear = fiscalYear;
        this.fiscalYearString = (this.fiscalYear - 1).toString();
        if (type === "plan") {
            this.prevFy = Number(fiscalYear) - 1;
            this.prevFyShort = String(this.prevFy).substring(2, 5);
        }
        // adjust minDate and maxDate accordingly to fiscalYear
        var year = new Date().getFullYear();
        var month = new Date().getMonth() + 1;
        // If the month is before April, the fiscal year is the previous year
        if (month < 4) {
            this.currentFiscalYear = year;
        }
        else {
            this.currentFiscalYear = year + 1;
        }
        if (this.currentFiscalYear < fiscalYear) {
            this.minDate = new Date(this.fiscalYear - 1 + "/04/01");
            this.maxDate = new Date(this.fiscalYear + "/03/30");
        }
        else {
            this.minDate = new Date(this.fiscalYear - 1 + "/" + month.toString() + "/01");
            this.maxDate = new Date(this.fiscalYear + "/03/30");
        }
        // Deadline extension: Allowing FY2026 reflections to be editable until July 1, 2026.
        var exceptionDeadline = new Date('2026-07-01');
        var today = new Date();
        var isDeadlineExtented = fiscalYear === 2026 && today < exceptionDeadline;
        if (fiscalYear === this.currentFiscalYear || isDeadlineExtented) {
            this.reflectionChangesDisabled = false;
        }
        else {
            this.reflectionChangesDisabled = true;
        }
        return new Promise(function (resolve) {
            _this.hoshinService.getHoshinForSingleUser(hoshinData).subscribe(function (res) {
                if (res != null && res !== undefined) {
                    _this.spinner.hide();
                    _this.reflectionStatusforPastFY =
                        res.reflectionStatusforAllApprovedHoshin;
                    _this.siteName = res.siteName;
                    _this.bpgName = res.bpgName;
                    _this.chapterId = res.chapterId;
                    _this.overallStatus = res.overallStatus;
                    _this.isAllHoshinsApproved = res.isAllHoshinsApproved;
                    _this.isAnyInitiativeRejected = res.isAnyInitiativeRejected;
                    _this.totalProposedBudget = res.totalProposedBudget;
                    _this.totalApprovedBudget = res.totalApprovedBudget;
                    _this.challenges = res.currentYearDetails.challenges;
                    _this.highlights = res.currentYearDetails.highlights;
                    _this.additionalAdminComments = res.currentYearDetails.additionalComments;
                    _this.prevHoshinStatus = res.prevYearDetails.hoshinStatus;
                    if (_this.overallStatus === "DRAFT" || _this.overallStatus === "NEW") {
                        _this.readOnly = false;
                    }
                    if (_this.overallStatus === "SUBMITTED") {
                        _this.readOnly = true;
                    }
                    else if (_this.overallStatus === "APPROVED") {
                        if (_this.adminId === "1") {
                            _this.readOnly = false;
                            _this.adminsEdit = true;
                        }
                        else {
                            _this.readOnly = true;
                            _this.adminsEdit = false;
                        }
                    }
                    else if (_this.overallStatus === "REJECTED") {
                        _this.adminsEdit = false;
                        _this.readOnly = false;
                    }
                    _this.isNaacViewOnly =
                        _this.isNaacUser() &&
                            (_this.overallStatus === "DRAFT" ||
                                _this.overallStatus === "NEW" ||
                                _this.overallStatus === "SUBMITTED");
                    if (_this.isNaacViewOnly) {
                        _this.readOnly = true;
                        _this.adminsEdit = false;
                    }
                    if (type === "plan") {
                        if (!_this.reflectionStatusforPastFY && fiscalYear > _this.currentFiscalYear && _this.prevHoshinStatus === "APPROVED") {
                            _this.pendingReflectionYear = fiscalYear - 1;
                            _this.msg = "The reflection for FY " + _this.pendingReflectionYear + " has not been completed. Please complete the reflection before proceeding with FY " + fiscalYear + " planning. You will be redirected automatically in 15 seconds, or you may navigate immediately using the button below.";
                            _this.showReflectionPopup = true;
                            _this.autoRedirectTimeout = setTimeout(function () {
                                if (_this.showReflectionPopup) {
                                    _this.showReflectionPopup = false;
                                    _this.confirmGoToReflection(_this.pendingReflectionYear);
                                }
                            }, 15000);
                        }
                        if (res.currentYearDetails != null && res.currentYearDetails !== undefined) {
                            _this.chapterGoals = res.currentYearDetails["chapterGoals"];
                            _this.chapterGoals = new DOMParser().parseFromString(_this.chapterGoals, "text/html").documentElement.textContent;
                            _this.affinityGoals = res.currentYearDetails["affinityGoals"];
                            _this.affinityGoals = new DOMParser().parseFromString(_this.affinityGoals, "text/html").documentElement.textContent;
                            _this.initiativeList = res.currentYearDetails["initiativeList"];
                            _this.isAnyInitiativeRejected = _this.initiativeList.some(function (i) { return i.isSuperAdminApproved === false; });
                            _this.goalsReview = res.currentYearDetails["goalsReview"];
                        }
                        if (res.prevYearDetails != null && res.prevYearDetails !== undefined) {
                            _this.prevchapterGoals = res.prevYearDetails["chapterGoals"];
                            _this.prevchapterGoals = new DOMParser().parseFromString(_this.prevchapterGoals, "text/html").documentElement.textContent;
                            _this.prevAffinityGoals = res.prevYearDetails["affinityGoals"];
                            _this.prevAffinityGoals = new DOMParser().parseFromString(_this.prevAffinityGoals, "text/html").documentElement.textContent;
                            _this.prevInitiativeList = res.prevYearDetails["initiativeList"];
                        }
                        _this.selectInitiative();
                        if (_this.initiativeList.length > 0) {
                            var validDrivers = _this.businessDriversList.map(function (d) { return d.type; });
                            for (var _a = 0, _b = _this.initiativeList; _a < _b.length; _a++) {
                                var initiative = _b[_a];
                                if (initiative.isCloned) {
                                    _this.cloneDisable = true;
                                }
                                if (initiative.businessDrivers && !validDrivers.includes(initiative.businessDrivers)) {
                                    initiative.businessDriversInvalid = true;
                                }
                            }
                        }
                        _this.getLeadDetails();
                        if (flag === "saveHoshin" || flag === "cancelKpi") {
                            _this.calculateMissingMandatoryFields();
                            _this.calculateMissingKpi();
                        }
                    }
                    if (type === "reflection") {
                        _this.isOverallReviewSelected = true;
                        _this.isKpiReviewSelected = false;
                        if (res.currentYearDetails != null && res.currentYearDetails !== undefined) {
                            _this.isNextYearPlanCompleted = res.isNextYearPlanCompleted;
                            _this.hoshinList = res.currentYearDetails["initiativeList"];
                            if (_this.hoshinList.length > 0) {
                                _this.isKpiReviewSelected = true;
                                _this.isOverallReviewSelected = false;
                            }
                            var c = "";
                            var h = "";
                            for (var _c = 0, _d = _this.hoshinList; _c < _d.length; _c++) {
                                var i = _d[_c];
                                c += i.bpgInitiative + " :\n- " + (i.challenges || "").trim() + "\n";
                                h += i.bpgInitiative + " :\n- " + (i.highlights || "").trim() + "\n";
                            }
                            c = c.trim();
                            h = h.trim();
                            _this.challenges = c + "\n";
                            _this.highlights = h + "\n";
                            _this.calculateMissingFieldsInReflectionScreen();
                        }
                    }
                }
                resolve();
            });
        });
    };
    HoshinComponent.prototype.editHoshin = function (data, flag) {
        this.submitButtonClicked = false;
        this.isGoalsSelected = false;
        this.isInitiativesSelected = false;
        this.isAddNewInitiativeSelected = true;
        this.isAddNewInitiative = true;
        this.initiativeName = data.bpgInitiative;
        this.bpgInitiative = data.bpgInitiative;
        this.businessDrivers = data.businessDriversInvalid ? null : data.businessDrivers;
        this.frequency = data.frequency;
        this.isAdditionalFundingSelected = data.isAdditionalFundingSelected;
        this.proposedBudget = data.proposedBudget;
        this.claimedAmount = data.claimedAmount;
        this.approvedBudget = data.superAdminApprovedBudget;
        this.leadId1 = data.leadId1;
        this.leadId2 = data.leadId2;
        this.additionalFunding = data.additionalFunding;
        this.additionalFundingSource = data.additionalFundingSource;
        this.actionPlan = data.actionPlan;
        this.why = data.why;
        this.plan = data.plan;
        this.how = data.how;
        this.locationWhere = data.locationWhere;
        this.what = data.what;
        this.actionPlan = new DOMParser().parseFromString(this.actionPlan, "text/html").documentElement.textContent;
        this.estimatedTiming = data.estimatedTiming;
        this.hoshinId = data.hoshinId;
        this.addToCalendar = data.addToCalendar == null ? true : data.addToCalendar;
        this.selectedKpiList = data.selectedKpiList ? data.selectedKpiList : [];
        var count = 0;
        if (this.selectedKpiList.length >= 1) {
            this.selectedKpiList.map(function (res) {
                if (res.isMasterKpi) {
                    count++;
                }
            });
        }
        this.enableSaveInitiativeButton = count > 0;
        this.kpiList = data.kpiList;
        this.superAdminApprovalComments = data.superAdminApprovalComment;
        this.isSuperAdminApproved = data.isSuperAdminApproved;
        if (flag === "approval") {
            this.addApproverComments();
        }
    };
    HoshinComponent.prototype.saveHoshin = function () {
        var _this = this;
        if (this.isNaacViewOnly) {
            return;
        }
        this.hoshinSuccess = false;
        this.newApprovedAmountGreater = false;
        var remainAmount = 0;
        var remainList = [];
        this.enableSaveInitiative();
        if (this.initiativeList.length > 0) {
            for (var _a = 0, _b = this.initiativeList; _a < _b.length; _a++) {
                var initiative = _b[_a];
                if (initiative.hoshinId !== this.hoshinId) {
                    remainList.push(initiative);
                }
            }
            remainList.forEach(function (res1) {
                remainAmount += res1.superAdminApprovedBudget;
            });
            remainAmount += this.approvedBudget;
        }
        if (this.overallStatus === "APPROVED" && this.newApprovedAmountGreater) {
            this.spinner.hide();
        }
        else {
            this.spinner.show();
            var iniativeData = {
                chapterId: this.chapterId,
                fiscalYear: this.fiscalYear,
                bpgInitiative: this.bpgInitiative,
                businessDrivers: this.businessDrivers,
                frequency: this.frequency,
                estimatedTiming: this.estimatedTiming,
                proposedBudget: this.proposedBudget,
                leadId1: this.leadId1,
                leadId2: this.leadId2,
                addToCalendar: this.addToCalendar,
                additionalFunding: this.additionalFunding,
                additionalFundingSource: this.additionalFundingSource,
                actionPlan: this.actionPlan,
                why: this.why,
                plan: this.plan,
                how: this.how,
                locationWhere: this.locationWhere,
                what: this.what,
                userId: this.userId,
                hoshinId: this.hoshinId,
                superAdminApprovedBudget: this.approvedBudget,
                isAdditionalFundingSelected: this.isAdditionalFundingSelected,
            };
            this.hoshinService.saveHoshinInitiative(iniativeData).subscribe(function (res) {
                if (res != null && res !== undefined) {
                    _this.hoshinId = res.hoshinId;
                    //added to update error message
                    _this.initiativeList.map(function (initiative) {
                        if (initiative.hoshinId === _this.hoshinId) {
                            initiative.bpgInitiative = res.bpgInitiative;
                            initiative.businessDrivers = res.businessDrivers;
                            initiative.businessDriversInvalid = false;
                            initiative.frequency = res.frequency;
                            initiative.estimatedTiming = res.estimatedTiming;
                            initiative.proposedBudget = res.proposedBudget;
                            initiative.leadId1 = res.leadId1;
                            initiative.leadId2 = res.leadId2;
                            initiative.additionalFunding = res.additionalFunding;
                            initiative.additionalFundingSource = res.additionalFundingSource;
                            initiative.actionPlan = res.actionPlan;
                            initiative.why = res.why;
                            initiative.plan = res.plan;
                            initiative.how = res.how;
                            initiative.locationWhere = res.locationWhere;
                            initiative.what = res.what;
                            initiative.addToCalendar = res.addToCalendar;
                            initiative.superAdminApprovedBudget =
                                res.superAdminApprovedBudget;
                            initiative.isAdditionalFundingSelected =
                                res.isAdditionalFundingSelected;
                            if (res.frequency === "Once" &&
                                res.estimatedTiming != null &&
                                res.estimatedTiming !== "") {
                                initiative.isValid = true;
                            }
                        }
                    });
                    window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
                    setTimeout(function () {
                        _this.isDetailsClicked = false;
                        _this.isKpiClicked = true;
                        _this.approveOrRejectHoshin = false;
                        _this.calculateMissingKpi();
                        _this.calculateMissingMandatoryFields();
                        _this.spinner.hide();
                    }, 2000);
                }
            });
        }
    };
    HoshinComponent.prototype.createBudgetId = function () {
        var _this = this;
        if (this.isNaacViewOnly) {
            return;
        }
        this.spinner.show();
        this.errorMsg = "";
        var goalData = {
            chapterId: this.chapterId,
            fiscalYear: this.fiscalYear,
            chapterGoals: this.chapterGoals,
            affinityGoals: this.affinityGoals,
            goalsReview: this.goalsReview,
            createdBy: this.userId,
        };
        this.hoshinService.saveHoshinGoals(goalData).subscribe(function (data) {
            if (_this.overallStatus === "NEW") {
                _this.overallStatus = "DRAFT";
            }
            _this.saveHoshin();
            window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
            if (data != null && data !== undefined) {
                setTimeout(function () {
                    _this.selectInitiative();
                    _this.spinner.hide();
                }, 2000);
            }
        });
    };
    HoshinComponent.prototype.toggleFundingCheckbox = function (e) {
        if (e.checked) {
            this.isAdditionalFundingSelected = true;
        }
        else {
            this.isAdditionalFundingSelected = false;
        }
    };
    HoshinComponent.prototype.resetHigh = function () {
        this.challenges = "";
        this.highlights = "";
    };
    HoshinComponent.prototype.deleteHoshin = function (hoshinId) {
        this.param = hoshinId;
        this.msg = "Are you sure you want to delete this initiative?";
        this.method = "deleteHoshinConfirmation";
    };
    HoshinComponent.prototype.deleteHoshinConfirmation = function (hoshinId) {
        var _this = this;
        if (this.isNaacViewOnly) {
            return;
        }
        this.submitButtonClicked = false;
        this.hoshinService
            .deleteHoshinInitative(this.userId, hoshinId)
            .subscribe(function (data) {
            _this.spinner.hide();
            if (data != null && data !== undefined) {
                _this.initiativeList = _this.initiativeList.filter(function (res) { return res.hoshinId !== hoshinId; });
                _this.calculateMissingKpi();
                _this.calculateMissingMandatoryFields();
                var isClonedInitiativePresent_1 = 0;
                _this.initiativeList.map(function (res) {
                    if (res.isCloned) {
                        isClonedInitiativePresent_1 += 1;
                    }
                });
                if (isClonedInitiativePresent_1 === 0) {
                    _this.cloneDisable = false;
                }
            }
        });
    };
    HoshinComponent.prototype.addNewKpi = function (data) {
        var _this = this;
        if (this.isNaacViewOnly) {
            return;
        }
        if (data === "add") {
            var kpiAlreadyAdded_1 = false;
            this.kpiExist = false;
            if (this.kpiNameEditable) {
                this.selectedKpiList.map(function (res) {
                    if (_this.selectedKpi === res.kpiId) {
                        _this.kpiExist = true;
                        kpiAlreadyAdded_1 = true;
                        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
                        setTimeout(function () {
                            _this.kpiExist = false;
                        }, 2000);
                    }
                });
                if (!kpiAlreadyAdded_1) {
                    this.kpiList.map(function (res) {
                        if (_this.selectedKpi === res.kpiId) {
                            res.kpiCount = _this.kpiCount;
                            _this.selectedKpiList = _this.selectedKpiList.concat(res);
                        }
                    });
                }
            }
            else {
                this.selectedKpiList.map(function (res) {
                    if (_this.kpiName.toLowerCase() === res.kpiName.toLowerCase()) {
                        _this.kpiExist = true;
                    }
                });
                if (this.kpiExist) {
                    window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
                    setTimeout(function () {
                        _this.kpiExist = false;
                    }, 2000);
                }
                else {
                    this.isEditKpi = false;
                    this.newkpiCount += 1;
                    this.selectedKpi = "newKpi" + this.newkpiCount.toString();
                    var newKpi = [
                        {
                            kpiId: this.selectedKpi,
                            kpiName: this.kpiName,
                            kpiCount: this.kpiCount,
                        },
                    ];
                    this.selectedKpiList = this.selectedKpiList.concat(newKpi);
                }
            }
        }
        else {
            this.selectedKpiList.map(function (res) {
                if (_this.selectedKpi === res.kpiId) {
                    res.kpiCount = _this.kpiCount;
                    res.kpiName = _this.kpiName;
                }
            });
        }
        this.kpiName = null;
        this.kpiCount = null;
        this.addCustomKpi = false;
        this.kpiNameEditable = false;
        this.isEditKpi = false;
        this.kpi = null;
        this.enableSaveInitiative();
    };
    // check whether min to one kpis from dropdown is selected to enable save initiative button
    HoshinComponent.prototype.enableSaveInitiative = function () {
        var count = 0;
        if (this.selectedKpiList.length >= 1) {
            this.selectedKpiList.map(function (res) {
                if (res.isMasterKpi) {
                    count++;
                }
            });
        }
        if (count >= 1) {
            this.enableSaveInitiativeButton = true;
        }
        else {
            this.enableSaveInitiativeButton = false;
        }
    };
    HoshinComponent.prototype.manageKpi = function (event) {
        this.addCustomKpi = true;
        this.kpiName = event.kpiName;
        this.selectedKpi = event.kpiId;
        this.kpiNameEditable = true;
        this.kpiExist = false;
    };
    HoshinComponent.prototype.editKpi = function (data) {
        var _this = this;
        this.kpiList.map(function (res) {
            if (data.kpiId === res.kpiId) {
                _this.kpiNameEditable = true;
            }
        });
        this.addCustomKpi = true;
        this.isEditKpi = true;
        this.selectedKpi = data.kpiId;
        this.kpiName = data.kpiName;
        this.kpiCount = data.kpiCount;
    };
    HoshinComponent.prototype.manageCustomKpi = function () {
        this.kpiNameEditable = false;
        this.addCustomKpi = true;
        this.kpi = null;
        this.kpiName = null;
        this.kpiCount = null;
    };
    HoshinComponent.prototype.deleteKpi = function (data) {
        var _this = this;
        this.isEditKpi = false;
        this.kpi = null;
        if (data.isActive) {
            this.hoshinService
                .deleteHoshinKpi(this.hoshinId, data.kpiId, this.userId)
                .subscribe(function (res) {
                if (res != null && res !== undefined) {
                    _this.selectedKpiList = _this.selectedKpiList.filter(function (res) { return res.kpiId !== data.kpiId; });
                    if (_this.selectedKpiList.length === 0) {
                        _this.initiativeList.map(function (response) {
                            if (response.hoshinId === _this.hoshinId) {
                                response.selectedKpiList = [];
                            }
                        });
                    }
                    _this.enableSaveInitiative();
                }
            });
        }
        else {
            this.selectedKpiList = this.selectedKpiList.filter(function (res) { return res.kpiId !== data.kpiId; });
            if (this.selectedKpiList.length === 0) {
                this.initiativeList.map(function (response) {
                    if (response.hoshinId === _this.hoshinId) {
                        response.selectedKpiList = [];
                    }
                });
            }
        }
    };
    HoshinComponent.prototype.saveKpi = function () {
        var _this = this;
        if (this.isNaacViewOnly) {
            return;
        }
        this.spinner.show();
        this.selectedKpiList.map(function (res) {
            if ((res.isMasterKpi === null ||
                res.isMasterKpi === undefined ||
                res.isMasterKpi === "") &&
                (res.isActive === null ||
                    res.isActive === undefined ||
                    res.isActive === "")) {
                res.kpiId = 0;
            }
        });
        var initiativeEvaluation;
        for (var _a = 0, _b = this.initiativeList; _a < _b.length; _a++) {
            var d = _b[_a];
            if (d.hoshinId === this.hoshinId) {
                initiativeEvaluation = {
                    challenges: d.challenges || "",
                    highlights: d.highlights || "",
                    evaluation: d.evaluation || "",
                };
            }
        }
        var kpiData = {
            hoshinId: this.hoshinId,
            selectedKpiList: this.selectedKpiList,
            initiativeEvaluation: "",
            highlights: "",
            challenges: "",
            userId: this.userId,
            fiscalYear: this.fiscalYear,
            chapterId: this.chapterId,
        };
        if (this.isSuperAdminApproved) {
            kpiData.initiativeEvaluation = initiativeEvaluation.evaluation;
            kpiData.highlights = (initiativeEvaluation.highlights || '').trim();
            kpiData.challenges = (initiativeEvaluation.challenges || '').trim();
        }
        this.hoshinService.saveHoshinKpi(kpiData).subscribe(function (res) {
            _this.spinner.hide();
            if (res != null && res !== undefined) {
                _this.kpiSuccess = true;
                _this.kpi = null;
                var hoshinId_1 = res.hoshinId;
                _this.initiativeList.map(function (response) {
                    if (response.hoshinId === hoshinId_1) {
                        response.selectedKpiList = res.selectedKpiList;
                    }
                });
                window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
                setTimeout(function () {
                    _this.kpiSuccess = false;
                    // to update all error messages
                    if (_this.yearList.length > 1 && _this.isAllHoshinsApproved) {
                        _this.getHoshinDetails(_this.fiscalYear, "reflection");
                        _this.yearList[0].isActive = true;
                        _this.yearList[1].isActive = false;
                    }
                    else {
                        _this.getHoshinDetails(_this.fiscalYear, "plan", "saveHoshin");
                        if (_this.yearList.length > 1) {
                            _this.yearList[0].isActive = false;
                            _this.yearList[1].isActive = true;
                        }
                        _this.calculateMissingKpi();
                        _this.calculateMissingMandatoryFields();
                        _this.errorMsg = "";
                        _this.isGoalsSelected = false;
                        _this.isInitiativesSelected = true;
                        _this.isKpiClicked = false;
                        _this.isDetailsClicked = true;
                        _this.isAddNewInitiativeSelected = false;
                    }
                }, 2000);
            }
        });
    };
    HoshinComponent.prototype.selectGoals = function () {
        this.submitButtonClicked = false;
        this.isGoalsSelected = true;
        this.isInitiativesSelected = false;
        this.newApprovedAmountGreater = false;
        this.errorMsgForMissingKpi = "";
    };
    HoshinComponent.prototype.selectInitiative = function () {
        this.submitButtonClicked = false;
        this.isGoalsSelected = false;
        this.isInitiativesSelected = true;
        this.isCloned = true;
        this.isAddNewInitiativeButtonSelected = true;
        this.errorMsg = "";
        this.calculateMissingKpi();
        this.calculateMissingMandatoryFields();
    };
    HoshinComponent.prototype.selectGoalsReview = function () {
        this.submitButtonClicked = false;
        this.isGoalsSelected = false;
        this.isInitiativesSelected = false;
        this.newApprovedAmountGreater = false;
        this.errorMsgForMissingKpi = "";
    };
    HoshinComponent.prototype.copyData = function (data) {
        var _this = this;
        if (this.isNaacViewOnly) {
            return;
        }
        if (data === "iniative") {
            this.spinner.show();
            this.submitButtonClicked = false;
            this.isGoalsSelected = false;
            this.isInitiativesSelected = true;
            this.isCloned = false;
            this.isAddNewInitiativeButtonSelected = true;
            var cloneData = {
                initiativeList: [],
                userId: this.userId,
                fiscalYear: Number(this.fiscalYear) - 1,
                chapterId: this.chapterId,
            };
            this.hoshinService.cloneHoshins(cloneData).subscribe(function (res) {
                _this.spinner.hide();
                if (res != null && res !== undefined) {
                    _this.cloneDisable = true;
                    _this.overallStatus = "DRAFT";
                    _this.prevInitiativeList = res.initiativeList
                        ? res.initiativeList
                        : [];
                    var validDrivers = _this.businessDriversList.map(function (d) { return d.type; });
                    for (var _a = 0, _b = _this.prevInitiativeList; _a < _b.length; _a++) {
                        var pre = _b[_a];
                        pre.isCloned = true;
                        if (pre.businessDrivers && !validDrivers.includes(pre.businessDrivers)) {
                            pre.businessDriversInvalid = true;
                        }
                    }
                    _this.initiativeList = _this.initiativeList.concat(_this.prevInitiativeList);
                    _this.calculateMissingKpi();
                    _this.calculateMissingMandatoryFields();
                    setTimeout(function () {
                        _this.isCloned = true;
                    }, 1000);
                }
            });
        }
    };
    HoshinComponent.prototype.addNewInitiative = function () {
        this.submitButtonClicked = false;
        this.initiativeName = "New Initiative";
        this.isGoalsSelected = false;
        this.isInitiativesSelected = false;
        this.isCloned = true;
        this.isAddNewInitiativeButtonSelected = true;
        this.resetHoshinInitiative();
        this.isAddNewInitiative = true;
        this.kpiSuccess = false;
        this.hoshinId = 0;
        this.isSuperAdminApproved = null;
    };
    HoshinComponent.prototype.resetHoshinInitiative = function () {
        this.newApprovedAmountGreater = false;
        this.bpgInitiative = "";
        this.frequency = null;
        this.proposedBudget = null;
        this.leadId1 = null;
        this.leadId2 = null;
        this.additionalFunding = null;
        this.additionalFundingSource = null;
        this.actionPlan = null;
        this.why = null;
        this.plan = null;
        this.how = null;
        this.locationWhere = null;
        this.what = null;
        this.estimatedTiming = null;
        this.selectedKpiList = [];
        this.kpiList = [];
        this.businessDrivers = null;
        this.isAdditionalFundingSelected = false;
        this.approvedBudget = null;
        this.addToCalendar = true;
    };
    HoshinComponent.prototype.resetKpi = function (data) {
        if (data === "cancelKpi") {
            this.getHoshinDetails(this.fiscalYear, "plan", data);
        }
        this.newApprovedAmountGreater = false;
        this.isAddNewInitiativeSelected = false;
        this.isGoalsSelected = false;
        this.isInitiativesSelected = true;
        this.isCloned = true;
        this.isAddNewInitiativeButtonSelected = true;
        this.isAddNewInitiative = false;
        this.kpiName = null;
        this.selectedKpi = null;
        this.kpi = null;
        this.kpiCount = null;
        this.addCustomKpi = false;
        this.isKpiClicked = false;
        this.isDetailsClicked = true;
        this.hoshinApproved = false;
        this.hoshinRejected = false;
        this.approveOrRejectHoshin = false;
    };
    HoshinComponent.prototype.detailsClick = function () {
        this.isDetailsClicked = true;
        this.isKpiClicked = false;
        this.approveOrRejectHoshin = false;
    };
    HoshinComponent.prototype.kpiClick = function () {
        this.isDetailsClicked = false;
        this.isKpiClicked = true;
        this.approveOrRejectHoshin = false;
        this.enableSaveInitiative();
    };
    HoshinComponent.prototype.approveOrReject = function (type) {
        this.method = "approveOrRejectConfirmation";
        this.param = type;
        if (type === "APPROVED") {
            this.msg = "Are you sure you want to approve this Annual Plan?";
        }
        else {
            this.msg = "Are you sure you want to decline this Annual Plan?";
        }
    };
    HoshinComponent.prototype.approveOrRejectConfirmation = function (type) {
        var _this = this;
        if (this.isNaacViewOnly) {
            return;
        }
        this.spinner.show();
        var submitData = {
            userId: this.userId,
            overallStatus: type,
            chapterId: this.chapterId,
            fiscalYear: this.fiscalYear,
            type: "overall",
        };
        this.hoshinService.approveorRejectHoshin(submitData).subscribe(function (res) {
            _this.spinner.hide();
            if (res != null && res !== undefined) {
                _this.overallStatus = res.overallStatus;
                if (_this.overallStatus === "APPROVED") {
                    _this.hoshinSubmitted = true;
                    _this.adminsEdit = true;
                    _this.readOnly = false;
                    _this.overallHoshinApproved = true;
                }
                else {
                    _this.hoshinSubmitted = false;
                    _this.adminsEdit = false;
                    _this.readOnly = false;
                    _this.overallHoshinRejected = true;
                }
                window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
                setTimeout(function () {
                    _this.overallHoshinApproved = false;
                    _this.overallHoshinRejected = false;
                    _this.getHoshinDetails(_this.fiscalYear, "plan");
                }, 2000);
            }
        });
    };
    HoshinComponent.prototype.addApproverComments = function () {
        var _this = this;
        this.isDetailsClicked = true;
        this.isKpiClicked = true;
        this.approveOrRejectHoshin = true;
        this.hoshinApproveClicked = false;
        this.approvedAmount = null;
        this.approveRejectComment = "";
        this.initiativeList.map(function (response) {
            if (response.hoshinId === _this.hoshinId) {
                if (response.isSuperAdminApproved) {
                    _this.hoshinApproveClicked = response.isSuperAdminApproved;
                    _this.isSuperAdminApproved = response.isSuperAdminApproved;
                    _this.approveRejectComment = response.superAdminApprovalComment
                        ? response.superAdminApprovalComment
                        : "";
                    _this.approvedAmount = response.superAdminApprovedBudget
                        ? response.superAdminApprovedBudget
                        : null;
                }
                else {
                    _this.isSuperAdminApproved = false;
                    _this.approveRejectComment = response.superAdminApprovalComment
                        ? response.superAdminApprovalComment
                        : "";
                }
            }
        });
    };
    HoshinComponent.prototype.selectKPIsReview = function () {
        this.submitButtonClicked = false;
        this.isKpiReviewSelected = true;
        this.isOverallReviewSelected = false;
    };
    HoshinComponent.prototype.selectOverallReview = function () {
        this.submitButtonClicked = false;
        this.isKpiReviewSelected = false;
        this.isOverallReviewSelected = true;
        this.errorMsg = "";
    };
    HoshinComponent.prototype.submitApproval = function (msg) {
        this.method = "submitApprovalConfirmation";
        if (msg === "approve") {
            this.msg = "Are you sure you want to approve this initiative?";
        }
        else {
            this.msg = "Are you sure you want to decline this initiative?";
        }
    };
    HoshinComponent.prototype.submitApprovalConfirmation = function () {
        var _this = this;
        if (this.isNaacViewOnly) {
            return;
        }
        this.spinner.show();
        this.approvedAmount = this.hoshinApproveClicked ? this.approvedAmount : 0;
        var approvalData = {
            userId: this.userId,
            hoshinId: this.hoshinId,
            isApproved: this.hoshinApproveClicked,
            approvalAmount: this.approvedAmount,
            comments: this.approveRejectComment,
            type: "individual",
        };
        this.hoshinService.approveorRejectHoshin(approvalData).subscribe(function (res) {
            if (res != null && res !== undefined) {
                _this.spinner.hide();
                _this.totalApprovedBudget = res.totalApprovedBudget;
                if (_this.hoshinApproveClicked) {
                    _this.hoshinApproved = true;
                    _this.hoshinRejected = false;
                }
                else {
                    _this.hoshinApproved = false;
                    _this.hoshinRejected = true;
                }
                window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
                setTimeout(function () {
                    _this.hoshinApproved = false;
                    _this.hoshinRejected = false;
                    _this.getHoshinDetails(_this.fiscalYear, _this.displayType);
                    _this.isGoalsSelected = false;
                    _this.isInitiativesSelected = true;
                    _this.isAddNewInitiativeSelected = false;
                    _this.isKpiClicked = false;
                }, 2000);
            }
        });
    };
    HoshinComponent.prototype.declineAll = function () {
        this.showDeclineAllModal = true;
        this.declineAllComment = '';
    };
    HoshinComponent.prototype.cancelDeclineAll = function () {
        this.showDeclineAllModal = false;
        this.declineAllComment = '';
    };
    HoshinComponent.prototype.confirmDeclineAll = function () {
        var _this = this;
        this.spinner.show();
        var declineAllData = {
            userId: this.userId,
            chapterId: this.chapterId,
            fiscalYear: this.fiscalYear,
            comments: this.declineAllComment,
            type: 'declineAll',
        };
        this.hoshinService.approveorRejectHoshin(declineAllData).subscribe(function (res) {
            _this.spinner.hide();
            if (res != null && res !== undefined) {
                _this.showDeclineAllModal = false;
                _this.declineAllComment = '';
                _this.hoshinRejected = true;
                window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
                setTimeout(function () {
                    _this.hoshinRejected = false;
                    _this.getHoshinDetails(_this.fiscalYear, _this.displayType);
                    _this.isGoalsSelected = false;
                    _this.isInitiativesSelected = true;
                    _this.isAddNewInitiativeSelected = false;
                    _this.isKpiClicked = false;
                }, 2000);
            }
        });
    };
    /** month year selection
     * @class CreateAndEditHoshinComponent
     * @method onOpenCalendar
     */
    HoshinComponent.prototype.onOpenCalendar = function (container) {
        container.monthSelectHandler = function (event) {
            container._store.dispatch(container._actions.select(event.date));
        };
        container.setViewMode("month");
    };
    /** on date change
     * @class CreateAndEditHoshinComponent
     * @method onDateChange
     */
    HoshinComponent.prototype.onDateChange = function (event, _i) {
        this.selectedMonthYear = event;
        var date = new Date(this.selectedMonthYear);
        var transformdate = this.datepipe.transform(date, "MMMM yyyy");
        this.estimatedTiming = transformdate.toString();
    };
    HoshinComponent.prototype.getBaseHoshin = function (data, i) {
        this.hoshinBase = data;
        this.isViewClicked = true;
        document
            .getElementById("bsaeHoshin" + i)
            .setAttribute(this.dataTargetConstant, "#bpgBaseModal");
        document
            .getElementById("bsaeHoshin" + i)
            .setAttribute(this.dataToggleConstant, "modal");
    };
    HoshinComponent.prototype.getKpi = function () {
        var _this = this;
        this.spinner.show();
        this.kpiList = [];
        this.hoshinService.getKpiDetails(this.businessDrivers).subscribe(function (data) {
            _this.kpiList = data;
            _this.spinner.hide();
        });
    };
    HoshinComponent.prototype.calculateMissingFieldsInReflectionScreen = function () {
        this.kpiReviewMissingFields = "";
        this.overallReviewMissingFields = "";
        var evaluationError = false;
        for (var _a = 0, _b = this.hoshinList; _a < _b.length; _a++) {
            var h = _b[_a];
            if (h.evaluation !== "" && h.evaluation != null) {
                //do nothing
            }
            else {
                evaluationError = true;
                break;
            }
        }
        if (evaluationError) {
            this.kpiReviewMissingFields =
                "Evaluation is required for all initiatives.";
        }
        if (this.challenges === null ||
            this.challenges === undefined ||
            this.challenges === "" ||
            this.highlights === null ||
            this.highlights === undefined ||
            this.highlights === "" ||
            evaluationError) {
            if (this.highlights === null ||
                this.highlights === undefined ||
                this.highlights === "") {
                if (this.overallReviewMissingFields === "") {
                    this.overallReviewMissingFields = "Highlights section is required.";
                }
            }
            if (this.challenges === null ||
                this.challenges === undefined ||
                this.challenges === "") {
                if (this.overallReviewMissingFields === "") {
                    this.overallReviewMissingFields = "Challenges section is required.";
                }
                else {
                    this.overallReviewMissingFields += " Challenges section is also required.";
                }
            }
        }
    };
    HoshinComponent.prototype.checkAllMandatoryDetailsFilledForReview = function (data) {
        this.submitButtonClicked = true;
        this.calculateMissingFieldsInReflectionScreen();
        if (data === "kpiReview") {
            if (this.kpiReviewMissingFields === "") {
                this.updateReview(data);
            }
        }
        else if (this.overallReviewMissingFields === "") {
            this.updateReview(data);
        }
    };
    HoshinComponent.prototype.updateReview = function (type) {
        var _this = this;
        this.submitButtonClicked = false;
        // added for showing overallreview on click of save button
        var isKPIEvaluationCompleted = false;
        this.spinner.show();
        this.errorMsg = "";
        var kpiReveiwList = [];
        this.hoshinList.forEach(function (initiative) {
            if (initiative.evaluation != null && initiative.evaluation !== "") {
                _this.saveKPIReviewDTO = {
                    hoshinId: initiative.hoshinId,
                    evaluation: initiative.evaluation,
                };
                kpiReveiwList.push(_this.saveKPIReviewDTO);
            }
            if (kpiReveiwList.length === _this.hoshinList.length) {
                isKPIEvaluationCompleted = true;
            }
        });
        var reviewData = {
            initiativeList: kpiReveiwList,
            additionalComments: this.additionalAdminComments,
            challenges: (this.challenges || '').trim(),
            highlights: (this.highlights || '').trim(),
            fiscalYear: this.fiscalYear,
            type: "review",
            userId: this.userId,
            chapterId: this.chapterId,
        };
        this.hoshinService.saveHoshinReview(reviewData).subscribe(function (data) {
            if (data) {
                window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
                if (type === "kpiReview") {
                    _this.selectOverallReview();
                    _this.spinner.hide();
                }
                else if (type === "partialSave") {
                    if (isKPIEvaluationCompleted) {
                        _this.kpiReviewMissingFields = "";
                        _this.isAddNewInitiative = false;
                        _this.selectOverallReview();
                    }
                    else {
                        _this.kpiReviewSaved = true;
                    }
                    _this.spinner.hide();
                }
                else {
                    _this.reviewSubmittedYear = _this.fiscalYear;
                    _this.getYears("saveReview");
                }
                if (_this.kpiReviewSaved) {
                    window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
                    setTimeout(function () {
                        _this.kpiReviewSaved = false;
                    }, 2000);
                }
            }
        });
    };
    HoshinComponent.prototype.submitPlanAndReview = function () {
        if (this.isNaacViewOnly) {
            return;
        }
        this.submitButtonClicked = true;
        this.errorMsg = "";
        this.calculateMissingKpi();
        this.calculateMissingMandatoryFields();
        if (this.initiativeList.length === 0) {
            if (this.errorMsg === "") {
                this.errorMsg = "At least one initiative is required to submit the Annual Plan.";
            }
            else {
                this.errorMsg += ", Initiatives";
            }
        }
        if (this.errorMsg === "" &&
            this.errorMsgForMissingKpi === "" &&
            this.errorMsgForMissingMandatoryFields === "") {
            document
                .getElementById("submitButton")
                .setAttribute(this.dataToggleConstant, "modal");
            document
                .getElementById("submitButton")
                .setAttribute(this.dataTargetConstant, "#myModal");
            this.method = "ConfirmSubmitPlanAndReview";
            this.msg = "Are you sure you want to submit this Annual Plan?";
        }
        else {
            this.submitButtonClicked = true;
            document
                .getElementById("submitButton")
                .removeAttribute(this.dataToggleConstant);
            document
                .getElementById("submitButton")
                .removeAttribute(this.dataTargetConstant);
        }
    };
    HoshinComponent.prototype.ConfirmSubmitPlanAndReview = function () {
        var _this = this;
        if (this.isNaacViewOnly) {
            return;
        }
        this.spinner.show();
        this.submitButtonClicked = false;
        var submitData = {
            chapterId: this.chapterId,
            userId: this.userId,
            planYear: this.fiscalYear,
            reviewYear: Number(this.fiscalYear) - 1,
            type: "submit",
        };
        this.hoshinService.submitHoshin(submitData).subscribe(function (res) {
            if (res != null && res !== undefined) {
                _this.spinner.hide();
                _this.hoshinSubmitted = true;
                _this.hoshinSubmit = true;
                window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
                setTimeout(function () {
                    _this.hoshinSubmit = false;
                    if (_this.adminId !== "1") {
                        _this.readOnly = true;
                    }
                    _this.getHoshinDetails(_this.fiscalYear, "plan");
                }, 2000);
            }
        });
    };
    HoshinComponent.prototype.calculateMissingKpi = function () {
        var _this = this;
        this.errorMsgForMissingKpi = "";
        if (this.initiativeList.length > 0 && this.fiscalYear > 2025) {
            this.initiativeList.map(function (i) {
                if (i.selectedKpiList === null || i.selectedKpiList.length < 1) {
                    if (_this.errorMsgForMissingKpi === "") {
                        _this.errorMsgForMissingKpi = i.bpgInitiative;
                    }
                    else {
                        _this.errorMsgForMissingKpi += ", " + i.bpgInitiative;
                    }
                }
            });
        }
    };
    HoshinComponent.prototype.calculateMissingMandatoryFields = function () {
        var _this = this;
        this.errorMsgForMissingMandatoryFields = "";
        if (this.initiativeList.length > 0) {
            this.initiativeList.map(function (i) {
                if (i.businessDriversInvalid ||
                    (_this.fiscalYear <= 2026 &&
                        (i.isValid === false ||
                            i.actionPlan === "" ||
                            i.actionPlan === null)) ||
                    (_this.fiscalYear > 2026 &&
                        (i.isValid === false ||
                            i.why === "" ||
                            i.why === null ||
                            i.what === "" ||
                            i.what === null ||
                            i.plan === "" ||
                            i.plan === null ||
                            i.how === "" ||
                            i.how === null ||
                            i.locationWhere === "" ||
                            i.locationWhere === null))) {
                    if (_this.errorMsgForMissingMandatoryFields === "") {
                        _this.errorMsgForMissingMandatoryFields = i.bpgInitiative;
                    }
                    else {
                        _this.errorMsgForMissingMandatoryFields += ", " + i.bpgInitiative;
                    }
                }
            });
        }
    };
    HoshinComponent.prototype.screenExit = function () {
        this.msg = "Are you sure you want to leave this page?";
        this.method = "confirmExit";
    };
    HoshinComponent.prototype.confirmExit = function () {
        this.router.navigate(["/annual-plan-home"]);
    };
    HoshinComponent.prototype.printHoshin = function () {
        this.printClicked = true;
        var printContents = document.getElementById("printHoshins").innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        this.spinner.hide();
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
        setTimeout(function () {
            this.printClicked = false;
        }.bind(this), 1000);
    };
    HoshinComponent.prototype.printReflection = function () {
        var _this = this;
        this.spinner.show();
        var planData = {
            userId: this.userId,
            adminId: this.adminId,
            fiscalYear: this.fiscalYear,
            type: "plan",
            siteId: this.siteId,
            bpgId: this.bpgId,
        };
        this.hoshinService.getHoshinForSingleUser(planData).subscribe(function (res) {
            if (res && res.currentYearDetails) {
                var planInitiativeList_1 = res.currentYearDetails["initiativeList"] || [];
                _this.hoshinList.forEach(function (h) {
                    var match = planInitiativeList_1.find(function (p) { return p.hoshinId === h.hoshinId; });
                    if (match) {
                        h.kpiList = match.selectedKpiList || [];
                    }
                });
            }
            _this.spinner.hide();
            _this.printTimestamp = new Date().toLocaleString('en-US', {
                month: '2-digit', day: '2-digit', year: 'numeric',
                hour: '2-digit', minute: '2-digit'
            });
            setTimeout(function () {
                var printContents = document.getElementById("printReflection").innerHTML;
                var originalContents = document.body.innerHTML;
                document.body.innerHTML = printContents;
                window.print();
                document.body.innerHTML = originalContents;
                window.location.reload();
            }, 300);
        });
    };
    HoshinComponent.prototype.printInitiatives = function () {
        if (!this.isInitiativePrintActive) {
            return;
        }
        this.printInitiativeHoshinList = this.hoshinList;
        this.printTimestamp = new Date().toLocaleString('en-US', {
            month: '2-digit', day: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
        setTimeout(function () {
            var printContents = document.getElementById("printInitiatives").innerHTML;
            var originalContents = document.body.innerHTML;
            document.body.innerHTML = printContents;
            window.print();
            document.body.innerHTML = originalContents;
            window.location.reload();
        }, 300);
    };
    HoshinComponent.prototype.logUserAction = function () {
        var data = {
            userId: this.userId,
            categoryDescription: "Annual Plan",
        };
        this.bpgCommonService.logUserAction(data).subscribe(function (_data) { });
    };
    HoshinComponent.prototype.getRemainingChars = function (text, length) {
        if (length === void 0) { length = 2000; }
        return length - (text ? text.length : 0);
    };
    HoshinComponent.prototype.goToKPIEdit = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, d;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.getHoshinDetails(this.fiscalYear, "plan")];
                    case 1:
                        _c.sent();
                        for (_a = 0, _b = this.initiativeList; _a < _b.length; _a++) {
                            d = _b[_a];
                            if (d.hoshinId === data.hoshinId) {
                                this.editHoshin(d);
                                this.kpiClick();
                                this.onKpiDataChange();
                                break;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    HoshinComponent.prototype.confirmGoToReflection = function (year) {
        var reflectionYear = parseInt(year);
        this.gotToPastReflection(reflectionYear);
    };
    HoshinComponent.prototype.gotToPastReflection = function (fy) {
        this.fy = Number(fy);
        this.getYears();
    };
    HoshinComponent.prototype.goTohoshinHome = function () {
        this.router.navigate(["/annual-plan-home"]);
    };
    HoshinComponent.prototype.goToPlan = function (fy) {
        this.getHoshinDetails(fy, "plan");
        this.yearList[1].isActive = true;
        this.yearList[0].isActive = false;
    };
    HoshinComponent.prototype.onKpiDataChange = function () {
        var missingFieldsSet = new Set();
        this.initiativeListHelper(missingFieldsSet);
        this.selectedKpiListHelper(missingFieldsSet);
        if (missingFieldsSet.size > 0) {
            this.kpiReviewMissingFields = "The following fields are required for this initiative: " + Array.from(missingFieldsSet).join(", ");
            this.enableSaveInitiativeButton = false;
        }
        else {
            this.enableSaveInitiativeButton = true;
        }
    };
    HoshinComponent.prototype.initiativeListHelper = function (missingFieldsSet) {
        for (var _a = 0, _b = this.initiativeList; _a < _b.length; _a++) {
            var d = _b[_a];
            if (d.hoshinId === this.hoshinId) {
                if (this.isEmpty(d.evaluation)) {
                    missingFieldsSet.add("evaluation");
                }
                if (this.isEmpty(d.challenges)) {
                    missingFieldsSet.add("challenges");
                }
                if (this.isEmpty(d.highlights)) {
                    missingFieldsSet.add("highlights");
                }
            }
        }
    };
    HoshinComponent.prototype.selectedKpiListHelper = function (missingFieldsSet) {
        for (var _a = 0, _b = this.selectedKpiList; _a < _b.length; _a++) {
            var h = _b[_a];
            if (this.isEmpty(h.kpiComments)) {
                missingFieldsSet.add("comments");
            }
            if (this.isEmpty(h.kpiAchievedCount)) {
                missingFieldsSet.add("achieved count");
            }
        }
    };
    HoshinComponent.prototype.isEmpty = function (value) {
        return (value === "" || value === null || value === "null" || value === undefined);
    };
    HoshinComponent.prototype.goToReflectionNow = function () {
        if (this.autoRedirectTimeout) {
            clearTimeout(this.autoRedirectTimeout);
            this.autoRedirectTimeout = null;
        }
        this.showReflectionPopup = false;
        this.confirmGoToReflection(this.pendingReflectionYear);
    };
    Object.defineProperty(HoshinComponent.prototype, "filteredUserListForLead1", {
        get: function () {
            var _this = this;
            if (!this.userList || this.userList.length === 0) {
                return [];
            }
            if (!this.leadId2) {
                return this.userList;
            }
            return this.userList.filter(function (user) { return user.userId !== _this.leadId2; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HoshinComponent.prototype, "filteredUserListForLead2", {
        get: function () {
            var _this = this;
            if (!this.userList || this.userList.length === 0) {
                return [];
            }
            if (!this.leadId1) {
                return this.userList;
            }
            return this.userList.filter(function (user) { return user.userId !== _this.leadId1; });
        },
        enumerable: true,
        configurable: true
    });
    HoshinComponent.prototype.getLeadDisplayName = function (userId) {
        if (this.isEmpty(userId) || !this.userList || this.userList.length === 0) {
            return "";
        }
        var user = this.userList.find(function (u) { return String(u.userId) === String(userId); });
        return user ? user.userFirstName : "";
    };
    Object.defineProperty(HoshinComponent.prototype, "isInitiativePrintActive", {
        get: function () {
            var s = this.overallStatus;
            return (s === "SUBMITTED" ||
                s === "APPROVED" ||
                s === "REJECTED");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HoshinComponent.prototype, "refMsgActive", {
        get: function () {
            if (this.overallStatus === 'APPROVED') {
                return false;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HoshinComponent.prototype, "isInitiativeFormDisabled", {
        get: function () {
            return (this.overallStatus === "SUBMITTED" ||
                this.isNaacViewOnly ||
                (this.overallStatus === "REJECTED" &&
                    (this.adminId === "4" || this.isNaacAdmin)) ||
                (this.overallStatus === "APPROVED" && this.adminId !== "1") ||
                (this.isSuperAdminApproved && this.adminId !== "1"));
        },
        enumerable: true,
        configurable: true
    });
    HoshinComponent.prototype.isNaacUser = function () {
        var id = String(this.adminId || "");
        return (this.isNaacAdmin ||
            id === "4" ||
            id.split(",").map(function (s) { return s.trim(); }).includes("4"));
    };
    return HoshinComponent;
}());
export { HoshinComponent };
